import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TooltipPosition } from '@progress/kendo-react-tooltip';
import cn from 'clsx';

import styles from './styles.module.scss';
import Tooltip from '@components-clean/core/tooltip';

type IconProps = {
    dataTestId: string;
    className?: string;
    tooltipPosition?: TooltipPosition;
    title?: string;
    icon: IconProp;
    isError?: boolean;
    isInactive?: boolean;
    isSuffix?: boolean;
    padding?: 'small' | 'regular' | 'none';
    maxWidth?: number;
    minWidth?: number;
};

export const Icon = ({
    dataTestId,
    className,
    tooltipPosition,
    title,
    icon,
    isError,
    isInactive,
    isSuffix,
    padding,
    maxWidth,
    minWidth,
}: IconProps) => {
    const wrapperClass = cn(`icon-tooltip${className ? `-${className}` : ''}`, {
        [styles.suffixPadding]: isSuffix,
        [styles.smallPadding]: padding === 'small',
        'k-p-0': padding === 'none',
    });

    const tooltipStyle: React.CSSProperties = {
        whiteSpace: 'pre-wrap',
    };

    if (maxWidth) {
        tooltipStyle.maxWidth = `${maxWidth}px`;
    }

    if (minWidth) {
        tooltipStyle.minWidth = `${minWidth}px`;
    }

    return (
        <Tooltip
            id={`${dataTestId}-tooltip`}
            position={tooltipPosition}
            parentTitle
            isError={isError}
            isInactive={isInactive}
            tooltipStyle={tooltipStyle}
            className="icon-tooltip"
        >
            <div title={title} className={wrapperClass}>
                <FontAwesomeIcon data-testid={dataTestId} className={className} fontSize={16} icon={icon} />
            </div>
        </Tooltip>
    );
};
